import { useState, useEffect } from 'react';

// eslint-disable-next-line max-len
const isGeoLocationAPIAvailable = () => Boolean(window && window.navigator && window.navigator.geolocation);

const useLocationManager = (enableOnLoad) => {
  const [isLocationEnabled, setIsLocationEnabled] = useState(false);
  const [currentLocation, setCurrentLocation] = useState();

  const handleError = (err) => {
    setIsLocationEnabled(
      !['PERMISSION_DENIED', 'POSITION_UNAVAILABLE', 'TIMEOUT'].includes(
        err.code,
      ),
    );
  };

  const updateLocation = (pos) => {
    setCurrentLocation({
      lat: pos.coords.latitude,
      lon: pos.coords.longitude,
    });
    setIsLocationEnabled(true);
  };

  const requestLocation = () => {
    if (isGeoLocationAPIAvailable()) {
      window.navigator.geolocation.getCurrentPosition(
        (position) => {
          updateLocation(position);
        },
        handleError,
      );
    }
  };

  useEffect(() => {
    if (enableOnLoad) {
      requestLocation();
    }
  }, []);

  useEffect(() => {
    if (isGeoLocationAPIAvailable() && isLocationEnabled) {
      const watchPosCounter = window.navigator.geolocation.watchPosition(
        updateLocation,
        handleError,
      );
      return window.navigator.geolocation.clearWatch(watchPosCounter);
    }
    return undefined;
  }, [isLocationEnabled]);

  return {
    isLocationEnabled,
    currentLocation,
    requestLocation,
  };
};

export default useLocationManager;
